/**
 * Sound effect mappings for the Eggs Fighting Game.
 *
 * Every call to `playEffect` in this feature references one of these constants —
 * no hardcoded strings at call sites. To swap a sound, change only its import here.
 *
 * Currently uses shared UI audio as placeholders. Replace each import with a
 * game-specific file (e.g. `../assets/audio/clash-1.wav`) once assets are ready.
 */
import clickSfx from "../../../assets/audio/click.wav";
import transitionSfx from "../../../assets/audio/transition.wav";
import swipeSfx from "../../../assets/audio/swipe.wav";
import dropSfx from "../../../assets/audio/drop.wav";
import zoomSfx from "../../../assets/audio/zoom.wav";
import paySfx from "../../../assets/audio/pay.wav";
import disconnectSfx from "../../../assets/audio/disconnect.wav";
import matchWinSound from "../assets/audio/win.mp3";
import matchLoseSound from "../assets/audio/lose.mp3";
import countdownFight from "../assets/audio/3-2-1-fight.mp3";

export const EGG_FIGHT_SOUNDS = {
  COUNTDOWN_PLUS_FIGHT: countdownFight,

  /** Plays on each countdown number: 3, 2, 1 */
  COUNTDOWN_TICK: clickSfx,

  /** Plays when the countdown hits 0 and "FIGHT!" appears */
  FIGHT_START: transitionSfx,

  /** First egg clash during the fight sequence */
  CLASH_1: swipeSfx,

  /** Second (harder) clash during the fight sequence */
  CLASH_2: dropSfx,

  /** Third clash in the fight sequence (just before the decisive hit) */
  CLASH_3: zoomSfx,

  /** The final decisive impact that ends the round */
  FINAL_HIT: zoomSfx,

  /** Local player wins the round */
  ROUND_WIN: paySfx,

  /** Local player loses the round */
  ROUND_LOSE: disconnectSfx,

  /** Local player wins the overall match */
  MATCH_WIN: matchWinSound,

  /** Local player loses the overall match */
  MATCH_LOSE: matchLoseSound,
} as const;
